import React, {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';

import './SubmitPost.css';
import {checkValidity} from "../../../Utils/utils";
import * as actions from "../../../store/actions";
import {LoadingIcon} from "../../../components/Loading/Loading";

const initialInputFieldState = {
    title: {
        label: "title",
        elementConfig: {
            type: "text",
            placeholder: "Enter title"
        },
        value: "",
        validation: {
            required: true,
            minLength: 6
        },
        valid: false,
        changed: false
    },
    url: {
        label: "url",
        elementConfig: {
            type: "url",
            placeholder: "Enter URL"
        },
        value: "",
        validation: {
            required: true,
            isURL: true
        },
        valid: false,
        changed: false
    }
}

const SubmitPost = (props) => {

    const [inputFields, setInputFields] = useState(initialInputFieldState)
    const [isFormValid, setIsFormValid] = useState(true)

    useEffect(() => {
        let flag = true
        for (let key in inputFields) {
            flag = flag && inputFields[key].valid
        }
        setIsFormValid(flag)
    }, [inputFields])

    const token = useSelector(state => state.auth.token)
    const isAuth = useSelector(state => state.auth.token !== null)
    const username = useSelector(state => state.auth.username)
    const userId = useSelector(state => state.auth.userId)
    const loading = useSelector(state => state.post.loading)
    const postSubmitSuccess = useSelector(state => state.post.postSummitStatus)

    const dispatch = useDispatch()
    const submitPost = useCallback((userId, postData, token) => dispatch(actions.postSubmit(userId, postData, token)), [dispatch])
    const submitPostInit = useCallback(() => dispatch(actions.postSubmitInit()), [dispatch])

    const onSubmitPost = (event) => {
        event.preventDefault()
        let url = inputFields.url.value
        if (!(url.startsWith("https://") || url.startsWith("http://"))) {
            url = "https://" + url
        }
        const postData = {
            title: inputFields.title.value,
            url: url,
            points: 0,
            comments: 0,
            upVoteBy: null,
            author: username,
            userId: userId,
            createdOn: new Date(),
        }
        submitPost(userId, postData, token)
    }

    useEffect(() => {
        submitPostInit()
        document.title = "Submit | Hacker News clone"
    }, [submitPostInit])

    const inputChangedHandler = (event, inputName) => {
        const updatedInputField = {
            ...inputFields[inputName]
        };
        updatedInputField.value = event.target.value
        updatedInputField.valid = checkValidity(updatedInputField.value, updatedInputField.validation)
        updatedInputField.changed = true
        setInputFields(state => ({...state, [inputName]: updatedInputField}))
    }

    const inputElementArray = []
    for (let key in inputFields) {
        inputElementArray.push({
            id: key,
            ...inputFields[key]
        });
    }
    let inputElements = inputElementArray.map(inputElement => {
        let error = false
        if (!inputElement.valid && inputElement.changed) {
            error = true
        }
        return (
            <tbody key={inputElement.id}>
            <tr>
                <td style={{paddingRight: "5px"}}><label>{inputElement.label}</label></td>
                <td>
                    <input
                        className={error ? "Invalid" : null}
                        type={inputElement.elementConfig.type}
                        placeholder={inputElement.elementConfig.placeholder}
                        value={inputElement.value}
                        onChange={(event) => inputChangedHandler(event, inputElement.id)}
                        size="50"
                    />
                </td>
            </tr>
            <tr style={{height: "5px"}}/>
            </tbody>
        )
    });

    return (
        <div className="SubmitPost">
            {!isAuth ? (<Redirect to={{
                pathname: "/auth",
                search: "?goto=submit"
            }}/>) : null}
            {postSubmitSuccess ? <Redirect to="/newest"/> : null}
            <form onSubmit={onSubmitPost}>
                <table>
                    {inputElements}
                    <tbody>
                    <tr style={{height: "5px"}}/>
                    <tr>
                        <td colSpan="1"/>
                        <td>
                            <button
                                onClick={onSubmitPost}
                                disabled={!isFormValid}
                            >
                                submit
                            </button>
                            &nbsp;&nbsp;
                            {loading ? <LoadingIcon size="0.75rem"/> : null}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </form>
        </div>
    )
}

export default SubmitPost;